var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-12 px-4"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"px-2 text-center",attrs:{"xs12":""}},[_c('h1',[_vm._v("404")]),_vm._v(" "),(_vm.customText)?_c('small',[_vm._v(" "+_vm._s(_vm.customText))]):_c('small',[_vm._v(_vm._s(_vm.$t(
          "common:errorMessage.pageDoesNotExist.text",
          "The page you are looking for does not exist"
        )))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }